import '../../css/base.css';

const Wifi = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Wifi</h2>
      <p className="your-stay-text">The cottage benefits from the super fast community broadband for your internet access.  You can use the appleTV for internet TV including netflix or you can connect your own devices.
       The wifi access code is <strong>aw8cpvXVr</strong>.
      </p>
    </div>
  );
}

export default Wifi;